import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";

/**
 * @export
 * @class CrossFieldErrorMatcher
 * @description Used to show that a field is invalid when the error is on the form and not on a specific control
 * 
 * Usage:
 *   <mat-select formControlName="CardExprMonth" [errorStateMatcher]="errorMatcher">
 * Example:
 *   in your component class
 *   public errorMatcher = new CrossFieldErrorMatcher(["invalidMonth"]);
 *   
 *   in your component template
 *   <mat-select formControlName="CardExprMonth" [errorStateMatcher]="errorMatcher">
 * 
 * https://itnext.io/materror-cross-field-validators-in-angular-material-7-97053b2ed0cf
 */
export class CrossFieldErrorMatcher implements ErrorStateMatcher
{
    constructor(private errors: string[])
    {

    }

    isErrorState(
        control: FormControl | null,
        form: FormGroupDirective | NgForm | null
    ): boolean
    {

        return (
            control.dirty &&
            form.invalid &&
            this.errors.some((error) => form.hasError(error))
        );
    }
}
